import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	uniapaSpotlightNotificationText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	uniapaSpotlightCloseButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	uniapaSpotlightViewRequestsButtonText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	uniapaSpotlightNotificationTextAppify: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	uniapaSpotlightNotificationText: {
		id: 'cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-notification-text',
		defaultMessage:
			"When someone in your team requests a new product you'll get a notification here now.",
		description: 'Message that gets displayed in UNIAPA spotlight message',
	},
	uniapaSpotlightCloseButtonText: {
		id: 'cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-close-button-text',
		defaultMessage: 'Close',
		description: 'Close button that gets displayed in UNIAPA spotlight message',
	},
	uniapaSpotlightViewRequestsButtonText: {
		id: 'cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-view-requests-button-text',
		defaultMessage: 'View requests',
		description: 'View requests button that gets displayed in UNIAPA spotlight message',
	},
	uniapaSpotlightNotificationTextAppify: {
		id: 'cross-flow-using-notifications-to-improve-admin-approval.uniapa-spotlight-notification-text-appify',
		defaultMessage:
			"When someone in your team requests a new app you'll get a notification here now.",
		description: 'Message that gets displayed in UNIAPA spotlight message',
	},
});
export default messages;
